import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import {useWindowResize} from '@ozgene/gp5.hooks.use-window-resize';
import {
  IntegratedSorting,
  SortingState,
  SelectionState,
  FilteringState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableSelection,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import {ColumnDefinedFilterCell} from 'util/components/ColumnDefinedFilterCell';
import {CustomRowComponent} from 'util/components/CustomRowComponent';
import {CustomNoDataCell} from 'util/components/CustomNoDataCell';
import {ColumnDefinedCell} from 'util/components/ColumnDefinedCell';

const cnsProcedureTableColumns = [
  {
    name: 'name',
    title: 'Name',
  },
];

export default function CnsProcedureList(props) {
  const {
    cnsProcedures,
    onSelectionChange,
    procedureFilterText,
    onChangeProcedureFilterText,
    selectedId,
  } = props;
  const [filters, setFilters] = useState([
    procedureFilterText.length > 0 && {
      columnName: 'name',
      operation: 'contains',
      value: procedureFilterText,
    },
  ]);
  const {height} = useWindowResize();
  const handleFiltersChange = useCallback(
    (newFilters) => {
      const procedureFilter = newFilters.find(({columnName}) => columnName === 'name');
      const procedureFilterValue = procedureFilter?.value ?? '';

      if (procedureFilterValue !== procedureFilterText) {
        onChangeProcedureFilterText(procedureFilterValue);
      }

      setFilters(newFilters);
    },
    [onChangeProcedureFilterText, procedureFilterText],
  );

  return (
    <Grid rows={cnsProcedures} columns={cnsProcedureTableColumns} getRowId={({id}) => id}>
      <FilteringState filters={filters} onFiltersChange={handleFiltersChange} />
      <SortingState defaultSorting={[{columnName: 'name', direction: 'asc'}]} />
      <SelectionState selection={[selectedId]} onSelectionChange={onSelectionChange} />
      <IntegratedFiltering />
      <IntegratedSorting />
      <VirtualTable
        height={height - 140}
        cellComponent={ColumnDefinedCell}
        noDataCellComponent={CustomNoDataCell}
      />
      <TableHeaderRow showSortingControls />
      <TableSelection
        selectByRowClick
        highlightRow
        showSelectionColumn={false}
        rowComponent={CustomRowComponent}
      />
      <TableFilterRow showFilterSelector cellComponent={ColumnDefinedFilterCell} />
    </Grid>
  );
}

CnsProcedureList.propTypes = {
  cnsProcedures: PropTypes.array.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  procedureFilterText: PropTypes.string.isRequired,
  onChangeProcedureFilterText: PropTypes.func.isRequired,
  selectedId: PropTypes.string,
};
